import React, { Component } from 'react';
import LoginForm from '../../components/LoginForm';

/**
 * Login screen, for showing login form.
 *
 * @extends React.Component
 */
class Login extends Component {
  render() {
    return (
      <div>
        &nbsp;
        <LoginForm />
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/screens/Login/index.js